import { useEffect } from "react";

const SHIMMER_CSS = `
@keyframes shimmer {
  0%   { background-position: -900px 0; }
  100% { background-position:  900px 0; }
}
.sk {
  background: linear-gradient(90deg, #ece9e4 25%, #f7f4f0 50%, #ece9e4 75%);
  background-size: 900px 100%;
  animation: shimmer 1.55s infinite linear;
  border-radius: 6px;
  flex-shrink: 0;
  display: block;
}
.sk-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}
.sk-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}
.sk-grid-2-1 {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}
.sk-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
@media (max-width: 900px) {
  .sk-grid-3   { grid-template-columns: repeat(2, 1fr); }
  .sk-grid-2-1 { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .sk-grid-3, .sk-grid-2, .sk-grid-2-1, .sk-panels {
    grid-template-columns: 1fr !important;
    gap: 14px;
  }
  .sk-hide-mobile { display: none !important; }
}
`;

export function useShimmer() {
  useEffect(() => {
    if (document.getElementById("sk-style")) return;
    const s = document.createElement("style");
    s.id = "sk-style";
    s.textContent = SHIMMER_CSS;
    document.head.appendChild(s);
  }, []);
}